import aImages from "./a-series/images.json";
import nImages from "./n-series/images.json";
import tImages from "./t-series/images.json";

import aThree from "./a-series/three";
import nThree from "./n-series/three";
import tThree from "./t-series/three";

import aOptions from "./a-series/options.json";
import nOptions from "./n-series/options.json";
import tOptions from "./t-series/options.json";

import aContext from "./a-series/context";
import nContext from "./n-series/context";
import tContext from "./t-series/context";

import aTranslations from "./a-series/translations.json";
import nTranslations from "./n-series/translations.json";
import tTranslations from "./t-series/translations.json";

import aDecorators from "./a-series/decorators";
import nDecorators from "./n-series/decorators";
import tDecorators from "./t-series/decorators";

const images = {
  "a-series": aImages,
  "n-series": nImages,
  "t-series": tImages,
};

const three = {
  "a-series": aThree,
  "n-series": nThree,
  "t-series": tThree,
};

const options = {
  "a-series": aOptions,
  "n-series": nOptions,
  "t-series": tOptions,
};

const context = {
  "a-series": aContext,
  "n-series": nContext,
  "t-series": tContext,
};

const translations = {
  "a-series": aTranslations,
  "n-series": nTranslations,
  "t-series": tTranslations,
};

const decorators = {
  "a-series": aDecorators,
  "n-series": nDecorators,
  "t-series": tDecorators,
};

export const series =
  window.location.hash.split("/").find((str) => str.includes("-series")) ||
  process.env.REACT_APP_SERIES;

const regex = new RegExp("^[a-z]{2}-[A-Z]{2}$", "g");
export const defaultLanguage = window.location.hash
  .split("/")
  .find((str) => str.match(regex) || str === "global");

export const hideHeader = !!window.location.hash
  .split("/")
  .find((str) => str === "hide-header");

export const showBackButton = !!window.location.hash
  .split("/")
  .find((str) => str === "show-back-button");

export const defaultEnvironment = window.location.hash
  .split("/")
  .find((str) => str === "showroom");

export const contact = window.location.hash
  .split("/")
  .find((str) => str === "contact");

export const share = window.location.hash
  .split("/")
  .find((str) => str === "share");

export const autostart =
  !!window.location.hash.split("/").find((str) => str === "autostart") ||
  process.env.REACT_APP_AUTOSTART === "true";

export const getThree = () => {
  return (series && three[series]) || three[process.env.REACT_APP_SERIES];
};

export const getOptions = () => {
  return (series && options[series]) || options[process.env.REACT_APP_SERIES];
};

export const getImages = () => {
  return (series && images[series]) || images[process.env.REACT_APP_SERIES];
};

export const getImage = (topic) => {
  return getImages().find((url) => url.includes(`${topic}-`));
};

export const getContext = () => {
  const result =
    (series && context[series]) || context[process.env.REACT_APP_SERIES];

  if (defaultLanguage) {
    (
      result.user.properties.find((prop) => prop.id === "language") || {}
    ).defaultValue = defaultLanguage;
  }

  if (defaultEnvironment) {
    (
      result.tractor.properties.find((prop) => prop.id === "environment") || {}
    ).defaultValue = defaultEnvironment;
  }

  return result;
};

export const getTranslations = () => {
  return (
    (series && translations[series]) ||
    translations[process.env.REACT_APP_SERIES]
  );
};

export const getDecorators = () => {
  return (
    (series && decorators[series]) || decorators[process.env.REACT_APP_SERIES]
  );
};
